import { Event } from '../../../base/common/event.js';
export { default as Severity } from '../../../base/common/severity.js';
var NotificationPriority;
( (function(NotificationPriority) {
    NotificationPriority[NotificationPriority["DEFAULT"] = 0] = "DEFAULT";
    NotificationPriority[NotificationPriority["SILENT"] = 1] = "SILENT";
    NotificationPriority[NotificationPriority["URGENT"] = 2] = "URGENT";
})(NotificationPriority || (NotificationPriority = {})));
var NeverShowAgainScope;
( (function(NeverShowAgainScope) {
    NeverShowAgainScope[NeverShowAgainScope["WORKSPACE"] = 0] = "WORKSPACE";
    NeverShowAgainScope[NeverShowAgainScope["PROFILE"] = 1] = "PROFILE";
    NeverShowAgainScope[NeverShowAgainScope["APPLICATION"] = 2] = "APPLICATION";
})(NeverShowAgainScope || (NeverShowAgainScope = {})));
function isNotificationSource(thing) {
    if (thing) {
        const candidate = thing;
        return typeof candidate.id === 'string' && typeof candidate.label === 'string';
    }
    return false;
}
var NotificationsFilter;
( (function(NotificationsFilter) {
    NotificationsFilter[NotificationsFilter["OFF"] = 0] = "OFF";
    NotificationsFilter[NotificationsFilter["ERROR"] = 1] = "ERROR";
})(NotificationsFilter || (NotificationsFilter = {})));
class NoOpNotification {
    constructor() {
        this.progress = ( new NoOpProgress());
        this.onDidClose = Event.None;
        this.onDidChangeVisibility = Event.None;
    }
    updateSeverity(severity) { }
    updateMessage(message) { }
    updateActions(actions) { }
    close() { }
}
class NoOpProgress {
    infinite() { }
    done() { }
    total(value) { }
    worked(value) { }
}
export { NeverShowAgainScope, NoOpNotification, NoOpProgress, NotificationPriority, NotificationsFilter, isNotificationSource };
